export enum AnswerCardRealizationMode {
    Study,
    Proof,
    Exam
}
